import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
  SET_RETURN_APPROVALS_LIST,
  SET_INITIAL_STATE,
  OPEN_RETURN_APPROVALS_ACTION_MODAL,
  CLOSE_RETURN_APPROVALS_ACTION_MODAL,
  SUBMIT_RETURN_APPROVALS_ACTION_PENDING,
  SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS,
  SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
  CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
  SET_RETURN_APPROVALS_FORM,
  RETURN_APPROVALS_LIST_ERROR,
  SET_PAGE_SIZE_GLOBAL,
  SET_RETURN_APPROVALS_LIST_COUNT,
  RETURN_APPROVALS_LIST_COUNT_ERROR,
  SET_RETURN_APPROVALS_PENDING,
  SET_ACTION,
  SET_SELECTED_REQUEST_ID,
} from "../returnApprovals/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";

export const setPageSizeGlobalReturn = (pageSize) => ({
  type: SET_PAGE_SIZE_GLOBAL,
  payload: { pageSize },
});

//-------------------------------RETURN_APPROVALS-LIST------------------------------------------
export const setReturnStatus = (actionType) => ({
  type: SET_ACTION,
  payload: { actionType },
});
export const setSelectedRequestId = (selectedId) => ({
  type: SET_SELECTED_REQUEST_ID,
  payload: { selectedId },
});
export const returnApprovalListError = (errorMessage) => ({
  type: RETURN_APPROVALS_LIST_ERROR,
  payload: { errorMessage },
});

export const returnApprovalListCountError = (errorMessage) => ({
  type: RETURN_APPROVALS_LIST_COUNT_ERROR,
  payload: { errorMessage },
});

export const setReturnApprovalsPending = () => ({
  type: SET_RETURN_APPROVALS_PENDING,
});

const setReturnApprovalsList = (returnApprovalsOdata) => ({
  type: SET_RETURN_APPROVALS_LIST,
  payload: { returnApprovalsOdata },
});
const setReturnApprovalsListCount = (returnApprovalsOdata) => ({
  type: SET_RETURN_APPROVALS_LIST_COUNT,
  payload: { returnApprovalsOdata },
});

export const getReturnApprovalsList = (page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setReturnApprovalsPending());
  getToken(dispatch).then((accessToken) => {
    agent.ReturnApproval.getReturnApprovals(accessToken, page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder)
      .then((returnApprovalList) => {
        dispatch(setReturnApprovalsList(returnApprovalList));
      })
      .catch((err) => {
        console.log("getApprovals server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(returnApprovalListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(returnApprovalListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getReturnApprovalsListCount = () => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.ReturnApproval.getReturnApprovalsCount(accessToken)
      .then((returnApprovalList) => {
        dispatch(setReturnApprovalsListCount(returnApprovalList));
      })
      .catch((err) => {
        console.log("getApprovals server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(returnApprovalListCountError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(returnApprovalListCountError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//-------------------------------RETURN_APPROVALS-ACTIONS---------------------------------------
export const setReturnApprovalsForm = (returnApprovalsForm) => ({
  type: SET_RETURN_APPROVALS_FORM,
  payload: { returnApprovalsForm },
});

export const submitReturnApprovalActionPending = () => ({
  type: SUBMIT_RETURN_APPROVALS_ACTION_PENDING,
});

export const submitReturnApprovalActionSuccess = () => ({
  type: SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS,
});

export const submitReturnApprovalActionError = (errorMessage) => ({
  type: SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
  payload: { errorMessage },
});

export const clearSubmitReturnApprovalActionError = () => ({
  type: CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
});

export const setRequestActionFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const openReturnApprovalActionModal = () => ({
  type: OPEN_RETURN_APPROVALS_ACTION_MODAL,
});

export const closeReturnApprovalActionModal = () => ({
  type: CLOSE_RETURN_APPROVALS_ACTION_MODAL,
});

export const submitReturnApprovalAction = (status, requestId) => (dispatch, getState) => {
  const currentState = getState();
  const { returnApprovalsForm, pageSizeGlobal } = currentState && currentState.returnApprovals;
  if (!returnApprovalsForm) {
    dispatch(submitReturnApprovalActionError("Please fill required details."));
    return;
  }

  const submitRequest = {
    Comments: returnApprovalsForm.Comments ? returnApprovalsForm.Comments.replaceAll("\n", " ") : null,
    ReturnStatus: status,
    ApprovalId: requestId,
  };

  dispatch(submitReturnApprovalActionPending());
  dispatch(clearSubmitReturnApprovalActionError());
  getToken(dispatch).then((accessToken) => {
    agent.ReturnApproval.submitReturnApproval(accessToken, submitRequest)
      .then((response) => {
        const { errors, returned } = response;
        let errorMessage = "";
        let deletedDeviceArr;
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            switch (key) {
              case "device_only_assign_previous_assigned_users":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} can only be returned to the person who assigned them to you. \n` : `Device ${value} can only be returned to the person who assigned it to you. \n`;

              case "given_device_not_assign_from_user":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Given devices ${value} have not been assigned to the returning user. \n` : `Given device ${value} has not been assigned to the returning user. \n`;

              case "master_device_cannot_return":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Given devices ${value} are master devices and cannot be returned. \n` : `Given device ${value} is a master device and cannot be returned. \n`;

              case "device_transaction_history_not_found":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Transaction history for the given devices ${value} were not found. \n` : `Transaction history for the given device ${value} was not found. \n`;

              case "master_device_cannot_return_while_connected_to_slave":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are masters with slaves. You can’t return a master device while connected to slaves. \n` : `Device ${value} is masters with slaves. You can’t return a master device while connected to slaves. \n`;

              case "invalid_serial_number":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Device key ${value} are invalid. \n` : `Device key ${value} is invalid. \n`;

              default:
                return errorMessage += "Something went wrong. Try again later.";
            }
          });
          dispatch(submitReturnApprovalActionError(errorMessage));
        }
        if (returned && Object.keys(returned).length !== 0) {
          Object.entries(returned).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            if (key === "deviceS_RETURNED_SUCCESSFULLY") {
              const message = (deviceArray && deviceArray.length) > 1 ? `${deviceArray} return request successfully approved` : `${deviceArray} return request successfully approved`;
              deletedDeviceArr = deviceArray;
              dispatch(submitReturnApprovalActionSuccess());
              // dispatch(clearForm());
              dispatch(getReturnApprovalsListCount());
              dispatch(closeReturnApprovalActionModal());
              dispatch(getReturnApprovalsList(1, pageSizeGlobal));
              dispatch(showSnackbarStatus(message));
            }
          })
        }
        if ((errors && Object.keys(errors).length === 0) && (returned && Object.keys(returned).length === 0)) {
          const message = "return request rejected`";
          dispatch(submitReturnApprovalActionSuccess());
          // dispatch(clearForm());
          dispatch(getReturnApprovalsListCount());
          dispatch(closeReturnApprovalActionModal());
          dispatch(getReturnApprovalsList(1, pageSizeGlobal));
          dispatch(showSnackbarStatus(message));
        }
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(submitReturnApprovalActionError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(submitReturnApprovalActionError(message));
        }
        console.log("submitReturnApprovalAction server error", err);
        // dispatch(clearForm());
        // dispatch(submitReturnApprovalActionError(null));
        // dispatch(closeReturnApprovalActionModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};